import Service from "../Service";

const resource = "usersap/";

export default {
    list(requestID) {
        return Service.post(
            resource + "list", {}, {
                params: { requestID: requestID },
            }
        );
    },
    listLocked(requestID) {
        return Service.post(
            resource + "listLocked", {}, {
                params: { requestID: requestID },
            }
        );
    },
    enabled(uss, requestID) {
        return Service.post(resource + "enabled", uss, {
            params: { requestID: requestID },
        });
    },
    mustChangePassword(uss, requestID) {
        return Service.post(resource + "mustchangepassword", uss, {
            params: { requestID: requestID },
        });
    },
    changePassword(uss, requestID) {
        return Service.post(resource + "changePassword", uss, {
            params: { requestID: requestID },
        });
    },
    save(uss, requestID) {
        return Service.post(resource + "save", uss, {
            params: { requestID: requestID },
        });
    },
    saveServiceLayer(uss, requestID) {
        return Service.post(resource + "saveServiceLayer", uss, {
            params: { requestID: requestID },
        });
    },
    getIP(requestID) {
        return Service.post(resource + "getIP", {}, {
            params: { requestID: requestID },
        });
    },
    listUsers(requestID) {
        return Service.post(resource + "listusers", {}, {
            params: { requestID: requestID },
        });
    },
    toggleUser(uss, requestID) {
        return Service.post(resource + "toggleuser", uss, {
            params: { requestID: requestID },
        });
    },
    toggleUserSap(uss, requestID) {
        return Service.post(resource + "toggleusersap", uss, {
            params: { requestID: requestID },
        });
    },
};